import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React, { useContext, useEffect, useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { AppDataConsumer, AppDataContext, AppDataProvider } from './common/AppContext';
import { FilterConsumer, FilterProvider } from './common/FilterContext';
import RouteConstants from './common/RouteConstants';
import PageNotFoundUI from './sharedComponents/emptyStateUIContainers/PageNotFoundUI';
import ErrorBoundary from './sharedComponents/errorBoundary/ErrorBoundary';

import CoachProfileMainContainer from './screens/coachProfile/CoachProfileMainContainer';
import CoachProfileEditMainContainer from './screens/coachProfileEdit/CoachProfileEditMainContainer';
import CoachProfileView from './screens/coachProfileView/CoachProfileViewContainer';
import AppHeaderBar from './sharedComponents/appBar/AppHeaderBar';

import CoachesManagementMainContainer from "./screens/CoachesManagement/CoachesManagementMainContainer";
import CoachLogin from './screens/coachLogin/CoachLogin';
import Logout from './screens/coachLogin/Logout';
import PrivacyPolicy from './screens/coachLogin/PrivacyPolicy';
import ForgotUsername from './screens/forgotPassword/ForgotUsername';
import ForgotPassword from './screens/forgotPassword/Forgotpassword';
import ResetPassword from './screens/forgotPassword/ResetPassword';

import './App.css';
import { Role } from './helper';
import FAQ from "./screens/FAQ/FAQ";
import ContactHelpDesk from "./screens/HelpDesk/contactHelpDesk";
import InviteUser from "./screens/InviteUser/InviteUser";
import UserMainContainer from './screens/admin/UserMainContainer';
import ChangeEmailId from "./screens/changeEmailId/ChangeEmailId";
import ChangePassword from "./screens/changePassword/ChangePassword";
import CoachRegistration from './screens/coachRegistration/CoachRegistration';
import { authenticationService, userService } from './services';
import { PrivateRoute } from './sharedComponents/PrivateRoute';

///// For Layout
import TagManager from 'react-gtm-module';
import AdminLayout from './Layout/adminLayout';
import CoachesProfileLayout from './Layout/coachesProfileLayout';
import FrontOfficeLayout from './Layout/frontOfficeLayout';
import ProfileEditMainContainer from "./screens/admin/CoachProfileEdit/ProfileEditMainContainer";
import Settings from "./screens/admin/settings/Settings";
import TermsAndConditions from "./screens/other/TermsAndConditions";
import ConfirmationDialog from './sharedComponents/dialog/ConfirmationDialog';

import { ToastProvider } from './context/SnackBarContext';
import { GameVideoProvider } from './context/GameVideoContext';
import Discovery from './discovery';
import CoachingTreeContainer from './screens/CoachingTree/CoachingTreeContainer';
import ManageData from './screens/ManageData/manageData';
import MediaManagementContainer from './screens/mediaManagement/MediaManagementContainer';
import AddEditMemo from './screens/memo/addEditMemo';
import MemoBoardContainer from './screens/memo/memoBoardContainer';
import UserMemoBoardContainer from './screens/memo/userMemoBoardContainer';
import ActiveShowCase from "./screens/other/ActiveShowCaseDialog";
import ShowcaseBoardContainer from './screens/showcase/showcaseBoardContainer';
import CreateSocialPost from './screens/socialCommunity/CreateSocialPost';
import SocialCommunityContainer from './screens/socialCommunity/SocialCommunityContainer';
import GroupContainer from './screens/userGroup/groupContainer';
import { UserProfileProvider } from './common/ProfileContext';
import AdminDashboardContainer from './Layout/adminDashboard/AdminDashboardContainer';
import { ThemeProviderWrapper } from './context/ThemeContext';
import EventCalendarScreen from './screens/calenderEvents/CalenderEventScreen';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        backgroundColor : theme.palette.mode === 'dark' ? "rgb(41, 41, 41)" : "rgb(231, 231, 231)"
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto',
        height: '100vh'
    },
    '@global': {
        '.MuiTabs-indicator': {
          backgroundColor: `${theme.palette.mode === 'dark'? theme.palette.secondary.dark : "#ffffff"} !important`, // 🔥 Force it globally
        },
      },
}));

function App() {

    const tagManagerArgs = {
        gtmId: 'GTM-NWV7RK7'
    }

    TagManager.initialize(tagManagerArgs)

    const [themeType, setThemeType] = useState('dark');

    //... See the theme colors at the bottom of this control.
    const theme = themeType === 'light' ? lightTheme : darkTheme;

    const handleThemeChange = (themeType) => {
        setThemeType(themeType);
    }

    return (
        // <CacheBuster>
        // {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        //   if (loading) return null;
        //   if (!loading && !isLatestVersion) {
        //     refreshCacheAndReload();
        //   }
        //   return (
        <ThemeProviderWrapper>
            <ErrorBoundary>
                <AppDataProvider>
                    <AppDataConsumer>
                        {props => {
                            return (
                                <ToastProvider>
                                    <GameVideoProvider>
                                        <AppRoute
                                            handleThemeChange={handleThemeChange}
                                            themeType={themeType}
                                        />
                                    </GameVideoProvider>
                                </ToastProvider>
                            )
                        }}
                    </AppDataConsumer>
                </AppDataProvider>
            </ErrorBoundary>
        </ThemeProviderWrapper>
    );
    // }}
    // </CacheBuster>
    //);
}
export default App;


const AppRoute = (props) => {
    const classes = useStyles();

    const [currentUser, setCurrentUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);

    const {
        mobileView,
        canISeeCoachingTree
    } = useContext(AppDataContext);

    //const networkStatus = useNetworkStatus();

    useEffect(() => {
        //... Register service worker.
        //registerServiceWorker();
        authenticationService.currentUser.subscribe(x => {
            setCurrentUser(x);
        });
        setIsAdmin(userService.getUserRole() == Role.Admin);
    }, []);


    function logout() {
        authenticationService.logout();
        window.location.href = '/';
    }

    return (
        <FilterProvider>
            <FilterConsumer>
                {(props) => {
                    return (
                        <div className={classes.root} >
                            <Router>
                                {currentUser && !mobileView &&
                                    <UserProfileProvider>
                                        <AppHeaderBar currentThemeType={props.themeType} onThemeChange={props.handleThemeChange} onLogout={logout}></AppHeaderBar>
                                    </UserProfileProvider>
                                }
                                <div className={classes.container}>
                                    <Routes>
                                        <Route path={RouteConstants.COACH_LOGIN} element={<CoachLogin />} />
                                        <Route path={RouteConstants.PRIVACY_POLICY} element={<PrivacyPolicy />} />
                                        <Route path={RouteConstants.DISCOVERY_PAGE} element={<Discovery />} />
                                        <Route path={RouteConstants.COACH_LOGOUT} element={<Logout />} />
                                        <Route path={RouteConstants.FORGOT_PASSWORD} element={<ForgotPassword />} />
                                        <Route path={RouteConstants.FORGOT_USERNAME} element={<ForgotUsername />} />
                                        <Route path={RouteConstants.RESET_PASSWORD} element={<ResetPassword />} />
                                        <Route path={RouteConstants.TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />
                                        <Route path={RouteConstants.ACTIVE_SHOWCASE} element={<ActiveShowCase open={false} />} />
                                        <Route path={RouteConstants.INVITE_SIGNUP} element={<CoachRegistration />} />
                                        
                                        <Route path={RouteConstants.COACH_CHANGE_PASSWORD} element={<PrivateRoute><CoachesProfileLayout><ChangePassword /></CoachesProfileLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.COACH_CHANGE_EMAIL} element={<PrivateRoute><CoachesProfileLayout><ChangeEmailId /></CoachesProfileLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.COACH_HELP_DESK} element={<PrivateRoute><CoachesProfileLayout><ContactHelpDesk /></CoachesProfileLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.COACH_FAQ} element={<PrivateRoute><CoachesProfileLayout><FAQ /></CoachesProfileLayout></PrivateRoute>} />

                                        <Route path={RouteConstants.COACH_PROFILE_VIEW} element={<PrivateRoute roles={[Role.Coach, Role.FrontOfficePlusCoach]}><CoachesProfileLayout><CoachProfileMainContainer /></CoachesProfileLayout></PrivateRoute>} />
                                        <Route path={`${RouteConstants.COACH_PROFILE_VIEW}/:coachName`} element={<PrivateRoute><CoachesProfileLayout><CoachProfileMainContainer /></CoachesProfileLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.COACH_PROFILE_EDIT} element={<PrivateRoute roles={[Role.Coach, Role.FrontOfficePlusCoach]}><CoachesProfileLayout><CoachProfileEditMainContainer /></CoachesProfileLayout></PrivateRoute>} />

                                        <Route path={`${RouteConstants.ADMIN_COACH_PROFILE_EDIT}/:userName`} element={<PrivateRoute roles={[Role.Admin]}><ProfileEditMainContainer /></PrivateRoute>} />
                                        <Route path={RouteConstants.DASHBOARD} element={<PrivateRoute roles={[Role.FrontOffice, Role.FrontOfficePlusCoach]}><FrontOfficeLayout><CoachesManagementMainContainer /></FrontOfficeLayout></PrivateRoute>} />
                                        <Route path={`${RouteConstants.COACHES_PROFILE_VIEW}/:userName`} element={<PrivateRoute roles={[Role.FrontOffice, Role.FrontOfficePlusCoach, Role.Admin, Role.Coach]}><CoachProfileView /></PrivateRoute>} />
                                        <Route path={RouteConstants.INVITE_USER} element={<PrivateRoute roles={[Role.Admin]}><CoachesProfileLayout><InviteUser /></CoachesProfileLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.ADMIN_SETTINGS} element={<PrivateRoute roles={[Role.Admin]}><CoachesProfileLayout><Settings /></CoachesProfileLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.USER_MANAGEMENT} element={<PrivateRoute roles={[Role.Admin]}><FrontOfficeLayout><UserMainContainer /></FrontOfficeLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.COACH_MANAGEMENT} element={<PrivateRoute roles={[Role.Admin]}><AdminLayout><CoachesManagementMainContainer /></AdminLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.ADMIN_MEMO} element={<PrivateRoute roles={[Role.Admin]}><AdminLayout><MemoBoardContainer /></AdminLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.ADMIN_SHOWCASE} element={<PrivateRoute roles={[Role.Admin]}><AdminLayout><ShowcaseBoardContainer /></AdminLayout></PrivateRoute>} />
                                        <Route path={`${RouteConstants.ADMIN_EDIT_MEMO}/:id`} element={<PrivateRoute><AdminLayout><AddEditMemo /></AdminLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.ADMIN_ADD_MEMO} element={<PrivateRoute><AdminLayout><AddEditMemo /></AdminLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.ADMIN_DASHBOARD} element={<PrivateRoute roles={[Role.Admin]}><AdminDashboardContainer /></PrivateRoute>} />
                                        <Route path={RouteConstants.ADMIN_GROUP} element={<PrivateRoute roles={[Role.Admin]}><AdminLayout><GroupContainer /></AdminLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.COACH_VIEW_USER_MEMO} element={<PrivateRoute><CoachesProfileLayout><UserMemoBoardContainer /></CoachesProfileLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.ADMIN_DATA} element={<PrivateRoute roles={[Role.Admin]}><AdminLayout><ManageData /></AdminLayout></PrivateRoute>} />
                                        {
                                            (canISeeCoachingTree !== undefined && canISeeCoachingTree === 'true') &&
                                            <Route path={RouteConstants.COACH_DASHBOARD} element={<PrivateRoute roles={[Role.Coach]}><FrontOfficeLayout><CoachesManagementMainContainer /></FrontOfficeLayout></PrivateRoute>} />
                                        }
                                        {
                                            (isAdmin == true || (canISeeCoachingTree !== undefined && canISeeCoachingTree === 'true')) &&
                                            <Route path={`${RouteConstants.COACHES_TREE}/:userName`} element={<PrivateRoute roles={[Role.FrontOffice, Role.FrontOfficePlusCoach, Role.Admin, Role.Coach]}><FrontOfficeLayout><CoachingTreeContainer /></FrontOfficeLayout></PrivateRoute>} />
                                        }
                                        <Route path={RouteConstants.CREATE_SOCIAL_POST} element={<PrivateRoute><CreateSocialPost /></PrivateRoute>} />
                                        <Route path={RouteConstants.SOCIAL_COMMUNITY_CONTAINER} element={<PrivateRoute roles={[Role.Admin, Role.Coach]}><SocialCommunityContainer /></PrivateRoute>} />
                                        <Route path={RouteConstants.MEDIA_MANAGEMENT} element={<PrivateRoute roles={[Role.Admin]}><AdminLayout><MediaManagementContainer /></AdminLayout></PrivateRoute>} />
                                        <Route path={RouteConstants.EVENT_CALENDAR} element={<PrivateRoute roles={[Role.FrontOffice, Role.FrontOfficePlusCoach, Role.Admin, Role.Coach]}><EventCalendarScreen /></PrivateRoute>} />
                                        <Route path="*" element={<PageNotFoundUI />} />
                                    </Routes>
                                </div>
                            </Router>
                        </div>
                    )
                }}
            </FilterConsumer>
        </FilterProvider>
    )


}


const darkTheme = createTheme({
    palette: {
        mode: "dark", // Assuming a dark theme based on background color
        primary: {
            main: "rgb(177, 198, 255)",
            contrastText: "rgb(0, 44, 112)",
            dark: "rgb(27, 67, 143)",
            light: "rgb(217, 226, 255)",
        },
        secondary: {
            main: "rgb(224, 113, 133)",
            contrastText: "rgb(104, 0, 17)",
            dark: "rgb(146, 0, 28)",
            light: "rgb(255, 218, 216)",
        },
        error: {
            main: "rgb(186, 26, 26)",
            contrastText: "rgb(255, 255, 255)",
            dark: "rgb(147, 0, 10)",
            light: "rgb(255, 180, 171)",
        },
        background: {
            default: "rgb(23, 25, 28)",
            paper: "rgb(29, 32, 36)",
        },
        header: {
            background: "rgb(23, 25, 28)",  // Same as background.default
            text: "rgb(228, 226, 230)", // Same as text.primary
        },
        text: {
            primary: "rgb(228, 226, 230)",
            secondary: "rgb(197, 198, 208)",
            disabled: "rgba(228, 226, 230, 0.38)",
        },
        divider: "rgb(59, 59, 59)",
        action: {
            disabled: "rgba(228, 226, 230, 0.38)",
            disabledBackground: "rgba(228, 226, 230, 0.12)",
        },
    },
    shadows: [
        "none",
        "0px 1px 3px 0px rgb(23, 25, 28)",
        "0px 1px 5px 0px rgb(29, 32, 36)",
        "0px 1px 8px 0px rgb(68, 70, 79)",
        "0px 2px 4px -1px rgb(143, 144, 153)",
        "0px 3px 5px -1px rgb(56, 49, 62)"
    ],
    //   overrides: {
    //     MuiOutlinedInput: {
    //       root: {
    //         "& .MuiOutlinedInput-notchedOutline": {
    //           borderColor: "rgb(241, 242, 247)", // Default outline color
    //         },
    //         "&:hover .MuiOutlinedInput-notchedOutline": {
    //           borderColor: "rgb(177, 198, 255)", // Change on hover
    //         },
    //         "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    //           borderColor: "rgb(177, 198, 255)", // Change on focus
    //           borderWidth: "2px",
    //         },
    //       },
    //     },
    //   },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: ".75rem",
                    fontWeight: 'normal',
                }
            }
        }
    }
});

const lightTheme = createTheme({
    palette: {
      mode: "light", // Light theme
      primary: {
        main: "#1d428a",
        contrastText: "rgb(255, 255, 255)",
        dark: "#172b5b",
        light: "rgb(217, 226, 255)",
      },
      secondary: {
        main: "rgb(191, 2, 41)",
        contrastText: "rgb(255, 255, 255)",
        dark: "rgb(65, 0, 7)",
        light: "rgb(255, 218, 216)",
      },
      error: {
        main: "rgb(186, 26, 26)",
        contrastText: "rgb(255, 255, 255)",
        dark: "rgb(65, 0, 2)",
        light: "rgb(255, 218, 214)",
      },
      background: {
        default: "rgb(254, 251, 255)",
        paper: "rgb(255, 255, 255)",
      },
      header: {
        background: "rgb(29, 66, 138)",
        text: "rgb(255, 255, 255)",
      },
      text: {
        primary: "rgb(29, 32, 36)",
        secondary: "rgb(68, 70, 79)",
        disabled: "rgba(29, 32, 36, 0.38)",
      },
      divider: "rgba(224,224,224,255)",
      action: {
        disabled: "rgba(29, 32, 36, 0.38)",
        disabledBackground: "rgba(29, 32, 36, 0.25)",
      },
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: ".75rem",
                    fontWeight: 'normal',
                }
            }
        }
    }
  });
//... Setting colors for the light and dark theme. 
// function getTheme(theme) {
//     return createMuiTheme({
//         palette: {
//             type: theme.paletteType,
//             primary: {
//                 main: (theme.paletteType === 'light') ? '#1d428a' : '#90caf9',
//                 //light: (theme.paletteType === 'light') ? '#8797bf' : '#a6d4fa',
//                 dark: (theme.paletteType === 'light') ? "#172b5b" : "#648dae"
//             },
//             secondary: {
//                 main: (theme.paletteType === 'light') ? '#c8102e' : '#f48fb1',
//             },
//         },
//         overrides: {
//             MuiTooltip: {
//                 tooltip: {
//                     fontSize: ".75rem",
//                     fontWeight: 'normal',
//                 }
//             }
//         }
//     });
// }